import { Component, inject, OnInit } from '@angular/core';
import {
  ProgramApplicationsService,
  ProgramApplicationStatusEnum,
  SupportedProgramsEnum,
} from '../../../../../data-access/programs/src/lib/program-applications.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Intercom } from '@supy-io/ngx-intercom';
import { BsChatService } from '@brightside-web/desktop/data-access/core-services';
import { Environment } from '@micro-core/environment';

@Component({
    selector: 'brightside-web-mpap',
    templateUrl: './mpap.component.html',
    styleUrls: ['./mpap.component.scss'],
    standalone: false
})
export class MpapComponent implements OnInit {
  sub = new Subscription();
  displayCta = false;
  ctaButtonInfo = {
    ctaKey: 'MPAP_START_APPLICATION',
    location: 'mpap/intro',
    applicationId: '',
  };
  processing: boolean;
  continueApp = [
    ProgramApplicationStatusEnum.CREATED,
    ProgramApplicationStatusEnum.DOCS_REQUESTED,
    ProgramApplicationStatusEnum.IN_PROGRESS,
  ];

  chatWithFA = [
    ProgramApplicationStatusEnum.DOCS_RECEIVED,
    ProgramApplicationStatusEnum.IN_REVIEW,
    ProgramApplicationStatusEnum.APPROVED,
    ProgramApplicationStatusEnum.DENIED,
    ProgramApplicationStatusEnum.CLOSED,
    ProgramApplicationStatusEnum.SUBMITTED,
  ];

  applicationId: string;

  // Loaded from the CDN so the income table can be updated without a web release
  private _env = inject(Environment);
  incomeGuidelinesImageUrl = `${this._env.cdnUrl}images/desktop/mpap_faq_income.png`;

  constructor(
    private programAppService: ProgramApplicationsService,
    private router: Router,
    private _bsChatService: BsChatService
  ) {}

  ngOnInit(): void {
    this.sub.add(
      this.programAppService.getProdAppStatus(SupportedProgramsEnum.MPAP).subscribe((response) => {
        if (response && response.status) {
          const resp = response.status as ProgramApplicationStatusEnum;
          if (this.continueApp.includes(resp)) {
            this.ctaButtonInfo = {
              ctaKey: 'MPAP_CONTINUE_APPLICATION',
              location: 'mpap/intro',
              applicationId: response.application_id,
            };
          } else if (this.chatWithFA.includes(resp)) {
            this.ctaButtonInfo = {
              ctaKey: 'MESSAGE_FA',
              location: 'chat',
              applicationId: '',
            };
          }
        }
        this.displayCta = true;
      })
    );
  }

  handleClick() {
    if (this.ctaButtonInfo.location === 'chat') {
      this._bsChatService.showChat();
    } else {
      this.processing = true;
      if (this.ctaButtonInfo.applicationId) {
        this.router.navigate([this.ctaButtonInfo.location], { queryParams: { applicationId: this.ctaButtonInfo.applicationId } });
      } else {
        this.router.navigate([this.ctaButtonInfo.location]);
      }
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
